/* eslint-disable no-return-assign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  TextInput, Select, Form, Button,
} from 'components/common';
import { MACHINE_CONDITION } from 'constants/common';
import { maxLengthValidator, nameWithNumberValidator } from 'utils/formValidators';

const MachineInformation = ({
  t, machineData, updateMachineData, setCurrentStep,
}) => {
  let formRef = useRef();

  useEffect(() => {
    if (!_.isEmpty(machineData.brand)) {
      formRef.setFieldsValue({
        brand: machineData.brand,
        machineType: machineData.machineType,
        model: machineData.model,
        serialNumber: machineData.serialNumber,
        condition: machineData.condition,
        workingHours: machineData.workingHours,
        machineYear: machineData.machineYear,
      });
    }
  }, []);

  const onFormSubmit = () => {
    setCurrentStep('PersonalInformation');
  };

  return (
    <div className="col-md-10 col-lg-6 offset-lg-1 mt-5 mt-md-0">
      <Form
        layout="vertical"
        onFinish={onFormSubmit}
        formRef={(ref) => formRef = ref}
      >
        <div className="fs-22 mb-2">{t('stepNumber', { step: 2 })}</div>
        <div className="fs-22 fw-900 mb-3">{t('enterTheMachineInformation')}</div>
        <div className="mb-5">
          İş makinanızın bilgilerini eksiksiz ve doğru girmeniz, makinanızın daha hızlı satılmasına olanak sağlayacaktır.
        </div>
        <div className="row mb-5">
          <div className="col-15">
            <div className="fs-18 fw-700 mb-4">Marka ve Model Bilgileri</div>
          </div>
          <div className="col-15">
            <div className="row mb-3">
              <div className="col">
                {/* Textfield için askıya alındı */}
                {/* <Select
                  name="brand"
                  value={machineData.brand}
                  placeholder={t('brand')}
                  onChange={updateMachineData}
                  options={_.map(sources.brands, (brand) => {
                    return { value: brand.id, text: brand.name };
                  })}
                  showSearch
                  filterOption={(input, opt) => opt.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  required
                /> */}
                <TextInput
                  name="brand"
                  placeholder={t('brand')}
                  value={machineData.model}
                  onChange={updateMachineData}
                  validator={nameWithNumberValidator}
                  required
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                {/* Textfield için askıya alındı */}
                {/* <Select
                  name="machineType"
                  value={machineData.machineType}
                  placeholder={t('machineType')}
                  onChange={updateMachineData}
                  options={_.map(sources.categories, (category) => {
                    return { value: category.id, text: getObjectByLanguage(category.name) };
                  })}
                  showSearch
                  filterOption={(input, opt) => opt.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  required
                /> */}
                <TextInput
                  name="machineType"
                  placeholder={t('machineType')}
                  value={machineData.machineType}
                  onChange={updateMachineData}
                  required
                  validator={nameWithNumberValidator}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <TextInput
                  name="model"
                  placeholder={`${t('model')} / ${t('type')}`}
                  value={machineData.model}
                  onChange={updateMachineData}
                  required
                  validator={nameWithNumberValidator}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <TextInput
                  type="text"
                  id="only-number"
                  name="serialNumber"
                  placeholder={t('serialNumber')}
                  value={machineData.serialNumber}
                  onChange={updateMachineData}
                  required
                  validator={nameWithNumberValidator}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row mb-5">
          <div className="col-15">
            <div className="fs-18 fw-700 mb-4">Çalışma Bilgileri</div>
          </div>
          <div className="col-15">
            <div className="row mb-3">
              <div className="col">
                <Select
                  name="condition"
                  value={machineData.condition}
                  placeholder={t('condition')}
                  onChange={updateMachineData}
                  options={[
                    { value: MACHINE_CONDITION.POOR, text: MACHINE_CONDITION.POOR },
                    { value: MACHINE_CONDITION.AVERAGE, text: MACHINE_CONDITION.AVERAGE },
                    { value: MACHINE_CONDITION.GOOD, text: MACHINE_CONDITION.GOOD },
                    { value: MACHINE_CONDITION.EXCELLENT, text: MACHINE_CONDITION.EXCELLENT },
                  ]}
                  required
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <TextInput
                  type="number"
                  id="only-number"
                  name="workingHours"
                  placeholder={t('workingHours')}
                  value={machineData.workingHours}
                  onChange={updateMachineData}
                  required
                  validator={(rule, value) => maxLengthValidator(value, 6)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <TextInput
                  type="number"
                  id="only-number"
                  name="machineYear"
                  placeholder={t('modelYear')}
                  value={machineData.machineYear}
                  onChange={updateMachineData}
                  required
                  validator={(rule, value) => maxLengthValidator(value, 4)}
                />
              </div>
            </div>
          </div>
        </div>

        <Button
          htmlType="submit"
          className="im-button im-button--primary im-button--fluid im-button--center mt-5 mb-5"
          label={t('next')}
        />
      </Form>
    </div>
  );
};

MachineInformation.propTypes = {
  t: PropTypes.func,
  machineData: PropTypes.object,
  updateMachineData: PropTypes.func,
  setCurrentStep: PropTypes.func,
};

export default MachineInformation;
